// Copyright (c) 2016 Deere & Company

import './index.scss';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import React, {PropTypes} from 'react';
import {
    getVsrMessage,
    hasVsrErrorForClaimField
} from '../../../services/claim-shared-helper';
import AmountOfUse from './amount-of-use-without-compliance';
import AmountOfUseWithCompliance from './amount-of-use-with-compliance';
import ClaimUseAmount from '@deere/cps-it.warranty-model-factory/lib/claim-use-amount';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';

const AmountOfUseField = props => {

    const vsrMessage = getVsrMessage(props.errors, 'amountOfUse', props.isEditable);
    const highlightClass = hasVsrErrorForClaimField(props.errors, 'amountOfUse', props.isEditable);
    const isValid = props.formValidation.useAmount && props.formValidation.useAmountUnit;
    const useAmount = props.useAmounts.length ?
        props.useAmounts[0].amount : '';
    const useAmountUnit = props.useAmounts.length ?
        props.useAmounts[0].unit : getKeyValuePairDefaultState();

    return (
        <div className='amount-of-use-field'>
            {props.complianceApplies ?
                <AmountOfUseWithCompliance
                    className='amount-of-use-with-compliance'
                    highlightClass={highlightClass}
                    isEditable={props.isEditable}
                    isValid={isValid}
                    onInputBlur={props.onInputBlur}
                    onInputChange={props.onInputChange}
                    useAmounts={props.useAmounts}
                    vsrMessage={vsrMessage}
                /> :
                    <AmountOfUse
                        allowedUnits={props.allowedUnits}
                        className='amount-of-use-without-compliance'
                        highlightClass={highlightClass}
                        isEditable={props.isEditable}
                        isValid={isValid}
                        onInputBlur={props.onInputBlur}
                        onInputChange={props.onInputChange}
                        onOptionBlur={props.onOptionBlur}
                        onOptionChange={props.onOptionChange}
                        selectedUnit={useAmountUnit}
                        showBlankOption={false}
                        value={useAmount}
                        vsrMessage={vsrMessage}
                    />
            }
        </div>
    );

};

AmountOfUseField.displayName = 'AmountOfUseField';
AmountOfUseField.propTypes = {
    allowedUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    complianceApplies: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired,
    formValidation: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    onInputBlur: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onOptionBlur: PropTypes.func.isRequired,
    onOptionChange: PropTypes.func.isRequired,
    useAmounts: PropTypes.arrayOf(PropTypes.instanceOf(ClaimUseAmount)).isRequired
};

export default AmountOfUseField;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/amount-of-use/index.js